import {
  LandingPageContextReducer,
  LandingPageReducerState,
  StoreEvents,
} from './index.d';

const reducer: LandingPageContextReducer = (state, action) => {
  const reducerActions: Record<StoreEvents, () => LandingPageReducerState> = {
    SET_IS_STICKY: () => {
      return {
        ...state,
        isSticky: action.payload,
      };
    },
  };

  return reducerActions[action.type] ? reducerActions[action.type]() : state;
};

export default reducer;
